import React from 'react'

const ConfirmContributorDetails = ({
    authorKey,
    name,
    membershipType,
    membershipTypeId
}) => {
    return (
        <div className="contact-search-panel">
            <h5 className="contact-search-panel-title mb-2">Confirm contributor details</h5>
            <div className="confirm-details-container">
                <div className="confirm-details-item">
                    <span className="confirm-details-label">Author key</span>
                    <span className="confirm-details-value">{authorKey || '-'}</span>
                </div>
                <div className="confirm-details-item">
                    <span className="confirm-details-label">Name</span>
                    <span className="confirm-details-value">{name || '-'}</span>
                </div>
                <div className="confirm-details-item">
                    <span className="confirm-details-label">Membership</span>
                    {membershipType ? (
                        <span className={`p-tag custom-badge-base custom-badge-orange-${membershipTypeId || 1}`}>
                            {membershipType}
                        </span>
                    ) : (
                        <span className="confirm-details-value">-</span>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ConfirmContributorDetails
